export default __webpack_public_path__ + "static/media/banner4.7713e7b8.jpg";